import {
	ActivateFlowStep,
	addOpacityToColor,
	buyFlowTextStyles,
	colours,
	mediaQuery,
	pxToRem,
} from "@helpers";
import { Actioner, GTMActionKeys } from "@services/actioner";
import React, { useEffect } from "react";
import styled from "styled-components";

import { useNavigation } from "@contexts/NavigationContainer";

import Button from "@components/BuyForm/Button";
import {
	FRAME_PADDING_HORIZONTAL_MOBILE,
	FRAME_PADDING_HORIZONTAL_TABLET,
	FRAME_PADDING_VERTICAL_MOBILE,
	FRAME_PADDING_VERTICAL_TABLET,
	FrameWithoutPadding,
} from "@components/BuyForm/Frame";
import { useBuyContext } from "@contexts/BuyContext";
import { simChannelAtom } from "@contextsactivateAtoms";
import { useAtom } from "jotai";

const FrameFooter = styled.div`
  background-color: ${colours.LIGHT_GREY};
  padding: ${pxToRem(20)} ${FRAME_PADDING_HORIZONTAL_MOBILE};

  ${mediaQuery.tabletAndUp} {
    padding: 1.25rem ${FRAME_PADDING_HORIZONTAL_TABLET} 1.25rem;
  }
`;

const ContinueFooter = styled(FrameFooter)`
  display: flex;
  flex-direction: column;
  padding: 1.5rem ${FRAME_PADDING_HORIZONTAL_MOBILE};
  #confirm-button {
    width: 100%;
    max-width: 300px;
    margin: auto;
  }

  ${mediaQuery.tabletAndUp} {
    flex-direction: row-reverse;
    padding: 1.75rem ${FRAME_PADDING_HORIZONTAL_TABLET};
  }
`;

const FrameContent = styled.div`
  padding: ${FRAME_PADDING_VERTICAL_MOBILE} ${FRAME_PADDING_HORIZONTAL_MOBILE}
    2.25rem;

  & + & {
    border-top: 1px solid ${addOpacityToColor(colours.MIDNIGHT_BLUE, 0.1)};
  }

  ${mediaQuery.tabletAndUp} {
    padding: ${FRAME_PADDING_VERTICAL_TABLET} ${FRAME_PADDING_HORIZONTAL_TABLET}
      2.25rem;
  }
`;

const ListItem = styled.li`
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
`;

const ListItemContent = styled.div`
  flex: 1;
  span {
    font-weight: bold;
  }
`;

const ListItemDetails = styled.div`
  ${buyFlowTextStyles.LARGE}
  margin-top: 0.25rem;

  p {
    ${buyFlowTextStyles.LARGE}
  }

  p br:first-child {
    display: none;
  }
`;

const ActivateYourSim = () => {
	const nextPage = ActivateFlowStep.RegisterSim;

	const [simChannel, setSimChannel] = useAtom(simChannelAtom);
	const { selectSIMType } = useBuyContext();

	useEffect(() => {
		setSimChannel("RETAIL");
		selectSIMType("PHYSICAL");
		Actioner.trigger(GTMActionKeys.BUY_SET_SIM_CHANNEL, {
			simChannel: simChannel || "RETAIL",
		});
	}, []);

	const { navigate, routeName } = useNavigation();

	useEffect(() => {
		Actioner.trigger(GTMActionKeys.FORM_START, {
			formName: "web_activate_retail",
		});
	}, []);

	const handleContinue = async () => {
		setSimChannel("RETAIL");

		Actioner.trigger(GTMActionKeys.FORM_STEP_COMPLETE, {
			formName: "web_activate_retail",
			formStepName: routeName,
		});
		navigate(nextPage, "");
	};

	return (
		<FrameWithoutPadding>
			<FrameContent>
				<ul>
					<ListItem>
						<ListItemContent>
							<ListItemDetails>
								<span>1. Register the SIM number</span> on your SIM card.
							</ListItemDetails>
						</ListItemContent>
					</ListItem>
					<ListItem>
						<ListItemContent>
							<ListItemDetails>
								<span>2. Confirm</span> your felix plan.
							</ListItemDetails>
						</ListItemContent>
					</ListItem>
					<ListItem>
						<ListItemContent>
							<ListItemDetails>
								<span>3. Set up</span> your account.
							</ListItemDetails>
						</ListItemContent>
					</ListItem>
					<ListItem>
						<ListItemContent>
							<ListItemDetails>
								<span>4. Download the felix app</span> to complete activating
								your new SIM.
							</ListItemDetails>
						</ListItemContent>
					</ListItem>
				</ul>
			</FrameContent>
			<ContinueFooter>
				<Button id="confirm-button" onClick={handleContinue}>
					Begin activation
				</Button>
			</ContinueFooter>
		</FrameWithoutPadding>
	);
};

export default ActivateYourSim;
